import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Fade from '@mui/material/Fade';
import { SxProps, useTheme } from '@mui/material/styles';
import { ReactNode } from 'react';
import { Link } from '../Link';
import { useMobile } from 'src/hooks/useMobile';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

type StyledChipProps = {
  outerSx?: SxProps;
  chipSx?: SxProps;
  label: ReactNode;
};

function StyledChip({ label, outerSx, chipSx }: StyledChipProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        ...outerSx,
      }}
    >
      <Fade in={true} style={{ transitionDelay: '75ms' }}>
        <Chip
          size="small"
          label={label}
          clickable
          variant="outlined"
          sx={{
            boxShadow: 1,
            ...chipSx,
          }}
        />
      </Fade>
    </Box>
  );
}

export type ChipViewCollectionProps = {
  url: string;
};

export function ChipViewCollection({ url }: ChipViewCollectionProps) {
  const theme = useTheme();
  const isMobile = useMobile();
  return (
    <Link href={url}>
      <StyledChip
        label={
          <span>
            View Collection
            <KeyboardDoubleArrowRightIcon
              sx={{
                height: '20px',
                width: '20px',
                mr: '-4px',
                mb: '-6px',
              }}
            />
          </span>
        }
        outerSx={{
          justifyContent: 'flex-end',
          position: 'absolute',
          bottom: isMobile ? 116 : 112,
          // right: 12,
          width: isMobile ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
          flexWrap: 'wrap',
        }}
        chipSx={{
          '&&:hover': {
            backgroundColor: theme.palette.background.elevation[8],
            cursor: 'pointer',
          },
          '& .MuiChip-label': {
            color: '#ffff',
          },
        }}
      />
    </Link>
  );
}
